export default "__VITE_ASSET__Cw6ksGA1__"